import { render, staticRenderFns } from "./adminUsers.vue?vue&type=template&id=0ad48e66&"
import script from "./adminUsers.vue?vue&type=script&lang=js&"
export * from "./adminUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports